import Router, { createRoutes } from './router/Router';
import ModalContainer from './common/ModalContainer';
import NavButtonsProvider from './common/NavButtonsProvider';
import Outlet from './router/Outlet';
import Topbar from './common/topbar/Topbar';
import WidgetsProvider from './common/WidgetsProvider';
import { ErrorBoundary } from './common/ErrorBoundary';
import ErrorMessageWithLink from './common/ErrorMessageWithLink';
import Betslip from './common/betslip/Betslip';
import { getRoutes } from './routes';
import { useContext } from 'react';
import { BetslipContext } from './data/betslip/BetslipConf';

export const urls = window.appConfig?.ROUTES ? {...window.xs_routes, ...window.appConfig.ROUTES} : window.xs_routes;
export const prematchPrefix = `${urls.base}${urls.prematch.home}`;
export const livePrefix = `${urls.base}${urls.live.home}`;
export const mybets = `${urls.base}/mybets`;

export function isPrematchRoute() {
    return window.location.pathname.startsWith(prematchPrefix);
}

export function isLiveRoute() {
    return window.location.pathname.startsWith(livePrefix);
}

export default function Container() {
	const betslipContext = useContext(BetslipContext);
    return (
        <ErrorBoundary fallback={<ErrorMessageWithLink />}>
            <div className="c_1">
                <div className="c_2">
                    <Router routes={createRoutes(getRoutes())} base={urls.base}>
                        <NavButtonsProvider>
                            <WidgetsProvider>
                                <Topbar />
                                <ErrorBoundary fallback={<ErrorMessageWithLink />}>
                                    <Outlet />
                                </ErrorBoundary>
                            </WidgetsProvider>
                        </NavButtonsProvider>
                    </Router>
                    {betslipContext.betslipData && <Betslip />}
                </div>
                <ModalContainer />
            </div>
        </ErrorBoundary>
    );
}
